export const suffixOptions = ["II", "III", "IV", "Jr", "Sr"] as const;

export type Suffix = typeof suffixOptions[number];
